import { render, staticRenderFns } from "./candidate-profile-modal-component.vue?vue&type=template&id=f53063ea&scoped=true"
import script from "./candidate-profile-modal-component.ts?vue&type=script&lang=ts&external"
export * from "./candidate-profile-modal-component.ts?vue&type=script&lang=ts&external"
import style0 from "./candidate-profile-modal-component.scss?vue&type=style&index=0&id=f53063ea&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53063ea",
  null
  
)

export default component.exports